import loadingIcon from "assets/img/icons/empty-identities.svg";
import useEffectOnce from "hooks/useEffectOnce";
import { useQuickCraftLogic } from "hooks/useQuickCraftLogic";
import { useSoundPath } from "hooks/useSoundPath";
import { CraftIdentityContext } from "pages/CraftIdentity";
import { useContext } from "react";
import { useLocation } from "react-router-dom";
import QuickCraftSteps from "./QuickCraftSteps";
import { createAPI } from "services/api/api";
import ModalWindow from "components/ModalWindow";

const QuickCraftWindow = () => {
  const api = createAPI();
  const playSound = useSoundPath();
  const { search } = useLocation();
  const { setMode, clearBlocks } = useContext(CraftIdentityContext);

  const searchParams = new URLSearchParams(search);
  const shortcutData = searchParams.get("shortcut_data")?.split(",") || [];

  const {
    identityName,
    data,
    step,
    isLoading,
    setIsLoading,
    choosedOptions,
    setChoosedOptions,
    fetchData,
    setStep,
  } = useQuickCraftLogic();

  useEffectOnce(() => {
    if (shortcutData.length === 4) {
      fetchData(shortcutData);
    }
  }, []);

  const closeWindow = () => {
    playSound("closeSubmenu");
    setMode("select");
  };

  const handleCraftButton = () => {
    playSound("crafting");

    setIsLoading(true);

    const findCardId = (label, collection, rarity) => {
      const dataItem = data.find((item) => item.label === label);
      if (!dataItem) return null;

      const card = dataItem.cards.find(
        (card) =>
          card.card_collection_name === collection &&
          card.rarity_name === rarity
      );
      return card ? card.id : null;
    };

    const payload = {
      nft_card_category_id: findCardId(
        "category",
        choosedOptions[0].category_collection,
        choosedOptions[0].category_rarity
      ),
      nft_card_month_id: findCardId(
        "month",
        choosedOptions[1].month_collection,
        choosedOptions[1].month_rarity
      ),
      nft_card_day_id: findCardId(
        "day",
        choosedOptions[2].day_collection,
        choosedOptions[2].day_rarity
      ),
      nft_card_year_id: findCardId(
        "year",
        choosedOptions[3].year_collection,
        choosedOptions[3].year_rarity
      ),
      celebrity_id: Number(shortcutData[0]),
    };

    api
      .post("/nft/craft_identity", payload)
      .then((res) => {
        if (res.status === 200) {
          setStep("success");
          clearBlocks();
        }
      })
      .catch((error) => {
        console.log(error);
        setStep("fail");
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <ModalWindow close={closeWindow}>
      <div
        className={`modal-window__wrapper
          ${step === 'start' ? 'modal-window__wrapper--craft-shortcut' : ''}
          ${step === 'success' ? 'modal-window__wrapper--success' : ''}
        `}
        onClick={(e) => e.stopPropagation()}
      >
        {isLoading ? (
          <img
            src={loadingIcon}
            alt=""
            className="card-details__craft-empty-loader"
          />
        ) : (
          <QuickCraftSteps
            name={identityName}
            step={step}
            closeWindow={closeWindow}
            handleCraftButton={handleCraftButton}
            data={data}
            choosedOptions={choosedOptions}
            setChoosedOptions={setChoosedOptions}
          />
        )}
      </div>
    </ModalWindow>
  );
};

export default QuickCraftWindow;
